import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Container, TopInfoWrapper } from './styles'
import { InfoBlock } from '../../../../../components'
import { timeConverterMMDDYYHHMM } from '../../../../../utils/dates'
import { useNavigate } from 'react-router-dom'

type OverviewProps = {
  snapshot: any
}

const Overview: FC<OverviewProps> = ({ snapshot }) => {
  const [t] = useTranslation()
  const navigate = useNavigate()

  const specifications = [
    {
      title: t("ID"),
      id: '1',
      value: snapshot.id
    },
    {
      title: t("REGION"),
      id: '2',
      value: snapshot.region || 'N/A'
    },
    {
      title: t("SIZE"),
      id: '3',
      value: `${snapshot.size} GB`
    },
    {
      title: t("CREATED_AT"),
      id: '4',
      value: timeConverterMMDDYYHHMM(snapshot.created_at)
    },
    {
      title: t("STATUS"),
      id: '5',
      value: snapshot.status || 'N/A'
    },
    {
      title: t("VOLUME"),
      id: '6',
      value: snapshot.volume_id ? (
        <span
          style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
          onClick={() => navigate(`/openstack/volumes/${snapshot.volume_id}/overview`)}
        >
          {snapshot.volume_id}
        </span>
      ) : 'N/A'
    },
    {
      title: t("DESCRIPTION"),
      id: '7',
      value: snapshot.description || 'N/A'
    },
  ]

  return (
    <Container>
      <TopInfoWrapper>
        <InfoBlock
          data={specifications}
          title={t("VOLUME_SNAPSHOT_SPECIFICATIONS")}
          customStyles={{ marginTop: '10px', width: "545px", flex: 'auto 1', marginRight: '10px' }}
        />
      </TopInfoWrapper>
    </Container>
  )
}

export default Overview
